<template src="./main.html"></template>


<script>
import storage from "@/services/storage";
import { mapState } from "vuex";

import LeftBar from "@/components/layout/LeftBar";
import ToolBar from "@/components/layout/ToolBar";

export default {
  components: {
    LeftBar,
    ToolBar,
  },

  data: () => ({
    menu: [],
    disabilitaBtn: false,
  }),

  methods: {
    async init() {
      try {
        // User info
        let res = await this.$store.dispatch("user/userInfo");

        this.menu = res.data.menu;

        // Voce di menu per la gestione auditor: non pilotata dal DB (nessuna
        // stored procedure da aggiornare), visibile solo per l'amministratore.
        if (res.data.roleId === "admin") {
          this.menu.push({
            text: "Gestione Auditor",
            img: "verified_user",
            link: "/gestioneAuditor",
            progOrder: 999,
          });
        }
      } catch (error) {
        console.log(this.$functions.getErrorMsg(error));
        this.$toast.info(this.$functions.getErrorMsg(error));
      }
    },

    loadCompanyCode() {
      if (this.getRole != "utente")
        if (this.companyCode && this.companyCode != "") {
          this.$store.commit("user/SET_USERSWITCH", {
            CompCode: this.companyCode,
            CompName: this.companyName,
          });
        } else this.$toast.alert("Nessun cliente selezionato");
    },

    async esci() {
      this.disabilitaBtn = true;

      try {
        await this.$store.dispatch("auth/logout");
      } catch (error) {
        console.log(this.$functions.getErrorMsg(error));
      }
    },

    showLeftBar() {
      this.$refs.leftBar.leftBarVis = !this.$refs.leftBar.leftBarVis;
    },
  },

  mounted() {
    this.init();
  },

  computed: {
    ...mapState({
      loading: (state) => state.app.loading,
      utente: (state) => state.user.username,
    }),

    companyCode() {
      return storage.getCompanyCode();
    },

    companyName() {
      return storage.getCompanyName();
    },

    compName() {
      return this.$store.getters["user/getCompanyName"];
    },
    compCode() {
      return this.$store.getters["user/getCompanyCode"];
    },

    getRole() {
      return this.$store.getters["user/getRole"];
    },

    utente() {
      return this.$store.getters["user/getNome"];
    },
  },

  watch: {
    message() {
      this.$toast.alert(this.message);
    },

    compCode(newVal) {
      if (!newVal && !this.companyCode) this.$toast.alert("Nessun cliente selezionato");
    },
  },
};
</script>